











































































































































































































































































































import { lessonDetails, lessonRollCall } from "@/api/rollCallDetails";
import { deleteLessonStudent } from "@/api/lesson";
import { dateFormat } from "@/utils/timeFormat";
import studentDialog from "./studentDialog.vue";
import { lessonStudentList } from "@/api/rollCallRecord";
import unableTpRollCall from "./unableToRollCall.vue";
import { Component, Prop, Vue } from "vue-property-decorator";
import { switchDetailApi } from "@/api/storeManagement";
@Component({
  name: "rollCallDetails",
  components: {
    studentDialog,
    unableTpRollCall,
  },
})
export default class extends Vue {
  activeName = "studentlist";
  tableData = [];
  page = 1;
  pageSize = 10;
  pageSizeArray = [10, 20, 50];
  total = 5;
  searchInfo = {};
  dialogVisible = false;
  followupList = [{ key: 1, value: "隐" }];
  dialogImageUrl = "";
  disabled = false;
  editbtn = true;
  detailsData: any = {
    class: {
      name: "",
    },
    course: {
      title: "",
    },
    teacher_list: [],
  };
  statistics = {
    signed: 0,
    late: 0,
    leave: 0,
    missed: 0,
  };
  id = 0;
  codeList = [];
  types = "";
  studentId = 0;
  classId = 0;
  student_list = [];
  abnormaList = [];
  loading: boolean = false;
  switch_detail: any = {}; //机构配置开关
  created() {
    const _t = this;
    _t.id = Number(_t.$route.query.id);
    _t.getData(_t.id);
    _t.getrollcallstudentlist();
    switchDetailApi().then((res: any) => {
      if (res.error_code === 0) {
        this.switch_detail = res.data;
      }
    });
  }
  inputConsume(e: any) {
    const _t = this as any;
    if (e.consume_number != "") {
      if (!/^\d+(\.\d{1,2})?$/.test(e.consume_number)) {
        _t.$message({
          type: "error",
          message: "请输入到小数点后两位",
        });
        const reg = /\d+(\.\d{1,2})?/g;
        const ret: any = reg.exec(e.consume_number);
        e.consume_number = ret[0];
      }
      if (
        Number(e.consume_number) > Number(e.course.account.usable_number) &&
        !e.consumeBtn
      ) {
        _t.$confirm(
          "学员剩余课时不足，修改后会导致课时超上，请及时联系学员续费。",
          `超上 - ${e.course.title}`,
          {
            confirmButtonText: "确定",
            confirmButtonClass: "mwow-button-filled success mini",
            cancelButtonText: "取消",
            cancelButtonClass: "mwow-button-filled mini",
            type: "warning",
          }
        )
          .then(() => {
            e.consumeBtn = true;
          })
          .catch(() => {
            e.consume_number = "";
          });
      }
    }
  }
  disabledClick(e: string) {
    const _t = this as any;
    _t.types = e;
    if (_t.tableData.length > 0) {
      _t.studentId = _t.tableData.map((a: any) => {
        return a.student_id;
      });
    }
    _t.classId = _t.detailsData.class_id;
    _t.disabled = true;
  }
  getTime(e: any) {
    return dateFormat("YYYY-mm-dd", e);
  }
  changeStudentStatus(e: any, type: number) {
    const _t = this as any;
    e.student_status = Number(type);
    if (Number(type) == 1 || Number(type) == 2) {
      e.consume_number = e.original;
    } else if (Number(type) == 3) {
      e.consume_number = e.leave_need_consume ? e.original : "0.00";
    } else if (Number(type) == 4) {
      e.consume_number = e.absent_need_consume ? e.original : "0.00";
    }
    _t.getstatistics(_t.tableData);
  }
  lookDetails(e: any, type: string) {
    const _t = this as any;
    console.log(e);
    if (e.student_status === 1) {
      // 正式学员
      _t.$confirm(
        `确定将${e.name}学员移除出本课次点名？仅为移出本课次点名，不会移出班级`,
        `确定移除 - ${e.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          _t.tableData.splice(_t.tableData.indexOf(e), 1);
        })
        .catch(() => {});
    } else {
      // 临时/体验学员
      _t.$confirm(
        `确定将${e.name}移出本次点名？如有需要可在点名记录中重新添加为临时点名学员。`,
        `确定移除 - ${e.name}`,
        {
          confirmButtonText: "确定",
          confirmButtonClass: "mwow-button-filled success mini",
          cancelButtonText: "取消",
          cancelButtonClass: "mwow-button-filled mini",
          type: "warning",
        }
      )
        .then(() => {
          deleteLessonStudent({
            lesson_id: _t.id,
            student_id: e.student_id,
          }).then((res: any) => {
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              _t.tableData.splice(_t.tableData.indexOf(e), 1);
              _t.getstatistics(_t.tableData);
            } else {
              this.$message({
                type: "error",
                message: "删除失败：" + res.message,
              });
            }
          });
        })
        .catch(() => {});
    }
  }
  getstatistics(e: any) {
    const _t = this as any;
    const statistics = {
      signed: 0,
      late: 0,
      leave: 0,
      missed: 0,
    };
    e.map((a: any) => {
      if (a.student_status == 1) {
        statistics.signed += 1;
      } else if (a.student_status == 2) {
        statistics.late += 1;
      } else if (a.student_status == 3) {
        statistics.leave += 1;
      } else if (a.student_status == 4) {
        statistics.missed += 1;
      }
    });
    _t.statistics = statistics;
  }
  completerallcall() {
    if (this.loading) {
      return false;
    }
    const _t = this as any;
    if (_t.tableData.length == 0) {
      _t.$message({
        type: "error",
        message: "暂无点名学员信息",
      });
      return;
    }
    const Nothing = _t.tableData.every((a: any) => {
      if (a.consume_number === "" || Number(a.consume_number) < 0) {
        return false;
      } else {
        return true;
      }
    });
    if (!Nothing) {
      _t.$message({
        type: "error",
        message: "请正确输入耗课数",
      });
      return;
    }
    _t.student_list = [];
    _t.tableData.map((a: any) => {
      _t.student_list.push({
        student_id: a.student_id,
        course_id: a.consume_course_id,
        student_type: a.student_type,
        student_status: a.student_status,
        consume_number: a.consume_number + "",
        remark: a.remark,
      });
    });
    this.loading = true;
    _t.$confirm(
      `本次课到课${_t.statistics.signed}人，迟到${_t.statistics.late}人，请假${_t.statistics.leave}人，未到课${_t.statistics.missed}人，无法点名${_t.abnormaList.length}人`,
      `点名提醒 - ${_t.detailsData.class.name}`,
      {
        confirmButtonText: "确定",
        confirmButtonClass: "mwow-button-filled success mini",
        cancelButtonText: "取消",
        cancelButtonClass: "mwow-button-filled mini",
        type: "warning",
      }
    )
      .then(() => {
        lessonRollCall({
          lesson_id: _t.id,
          student_list: _t.student_list,
        }).then((res: any) => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          if (res.error_code == 0) {
            _t.$message({
              type: "success",
              message: "点名成功",
            });
            _t.goBack();
          } else {
            _t.$message({
              type: "error",
              message: res.message,
            });
          }
        });
      })
      .catch(() => {
        this.loading = false;
      });
  }
  getrollcallstudentlist() {
    const _t = this as any;
    lessonStudentList({ lesson_id: _t.id }).then((res: any) => {
      if (res.error_code == 0) {
        const normal: any = [];
        const abnormal: any = [];
        if (res.data.list != null && res.data.list.length > 0) {
          res.data.list.map((a: any) => {
            a.remark = a.remark == "" ? "" : a.remark;
            a.original = a.consume_number;
            if (a.student_status == 3 || a.student_status == 4) {
              a.consume_number =
                !!a.leave_need_consume || !!a.absent_need_consume
                  ? a.consume_number
                  : 0;
            }
            switch (a.student_status) {
              case 1:
                a.student_statusName = "到课";
                break;
              case 2:
                a.student_statusName = "迟到";
                break;
              case 3:
                a.student_statusName = "请假";
                break;
              case 4:
                a.student_statusName = "未到课";
                break;
            }
            if (
              (a.course && a.course.account.expire_status == 1) ||
              (a.course && a.course.account.stop_status == 2) ||
              (a.course &&
                Number(a.course.account.usable_number) <
                  Number(this.detailsData.class.consume_number) &&
                this.switch_detail.student_exceed === 2)
            ) {
              a.consume_number = this.detailsData.class.consume_number; // 本节课点名耗课数
              a.student_exceed = this.switch_detail.student_exceed; // 是否开启超上
              abnormal.push(a);
            } else {
              normal.push(a);
            }
          });
        }
        _t.tableData = normal;
        _t.abnormaList = abnormal;
        _t.getstatistics(_t.tableData);
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  getData(id: number) {
    const _t = this as any;
    lessonDetails({ lesson_id: id }).then((res: any) => {
      if (res.error_code == 0) {
        _t.detailsData = res.data;
      } else {
        _t.$message({
          type: "error",
          message: res.message,
        });
      }
    });
  }
  updateList(e: any) {
    const _t = this as any;
    _t.getListData();
    _t.getstatistics(_t.tableData);
  }
  goBack() {
    this.$router.go(-1);
  }
  handleClick(tab: any, event: any) {
    const _t = this as any;
    _t.page = 1;
    _t.pageSize = 10;
    _t.getListData();
  }
  getListData() {
    const _t = this as any;
    _t.getrollcallstudentlist();
  }
  handlePagerChange(e: number) {
    this.page = e;
    this.getListData();
  }
  handlePagerSizeChange(e: number) {
    this.pageSize = e;
    this.getListData();
  }
}
